/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContractRubricSummary
 */
export interface ContractRubricSummary {
    /**
     * 
     */
    title: string;
    /**
     * 
     */
    sort_order: number;
}

/**
 * Check if a given object implements the ContractRubricSummary interface.
 */
export function instanceOfContractRubricSummary(value: object): value is ContractRubricSummary {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('sort_order' in value) || value['sort_order'] === undefined) return false;
    return true;
}

export function ContractRubricSummaryFromJSON(json: any): ContractRubricSummary {
    return ContractRubricSummaryFromJSONTyped(json, false);
}

export function ContractRubricSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractRubricSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'sort_order': json['sort_order'],
    };
}

export function ContractRubricSummaryToJSON(json: any): ContractRubricSummary {
    return ContractRubricSummaryToJSONTyped(json, false);
}

export function ContractRubricSummaryToJSONTyped(value?: ContractRubricSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'sort_order': value['sort_order'],
    };
}

